/**
 * Layout algorithm for Rhythm Gallery: chunks photos into hero (1), rhythm (8), uniform (5) blocks.
 * Pattern repeats every 14 photos; remainder is handled with shorter blocks.
 */

export interface GalleryPhoto {
   id: string;
   url: string;
   thumbnailUrl?: string;
   title?: string;
   mediaType?: string;
   videoUrl?: string;
   [key: string]: any;
}

export interface LayoutBlock {
   type: 'hero' | 'rhythm' | 'uniform';
   photos: GalleryPhoto[];
   startIndex: number;
}

const HERO_COUNT = 1;
const RHYTHM_COUNT = 8;
const UNIFORM_COUNT = 5;
const PATTERN_SIZE = HERO_COUNT + RHYTHM_COUNT + UNIFORM_COUNT;

export function generateLayoutBlocks(photos: GalleryPhoto[]): LayoutBlock[] {
   const blocks: LayoutBlock[] = [];
   let index = 0;

   while (index < photos.length) {
      // Hero block (1 photo)
      if (index < photos.length) {
         const heroPhotos = photos.slice(index, index + HERO_COUNT);
         if (heroPhotos.length > 0) {
            blocks.push({
               type: 'hero',
               photos: heroPhotos,
               startIndex: index,
            });
            index += heroPhotos.length;
         }
      }

      // Rhythm block (up to 8 photos)
      if (index < photos.length) {
         const rhythmPhotos = photos.slice(index, index + RHYTHM_COUNT);
         if (rhythmPhotos.length > 0) {
            blocks.push({
               type: 'rhythm',
               photos: rhythmPhotos,
               startIndex: index,
            });
            index += rhythmPhotos.length;
         }
      }

      // Uniform row (up to 5 photos)
      if (index < photos.length) {
         const uniformPhotos = photos.slice(index, index + UNIFORM_COUNT);
         if (uniformPhotos.length > 0) {
            blocks.push({
               type: 'uniform',
               photos: uniformPhotos,
               startIndex: index,
            });
            index += uniformPhotos.length;
         }
      }
   }

   return blocks;
}
